import { GlobalResponseObject } from "@needle-management/shared-models";
import { PointTypesResponseDto } from "./point-types-response-dto";

export class PointTypesResponse extends GlobalResponseObject{
    data ?: PointTypesResponseDto[];

    constructor(status: boolean, errorCode: number, internalMessage: string, data: PointTypesResponseDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}